import { SidebarSimple } from "@phosphor-icons/react"

import { cn } from "~/utils/helpers"

// A CSS transition rather than motion, which costs a motion instance per layer in every peek button.
const LAYER =
  "absolute inset-0 inline-flex items-center justify-center transition-opacity duration-180 ease-[cubic-bezier(0.22,1,0.36,1)]"

/**
 * The inspector's open/closed glyph: a regular↔fill crossfade of one icon, so the state change
 * reads as one object changing. Shared by the toolbar toggle and the in-cell peek button.
 */
const InspectorToggleIcon = ({ isOpen }: { isOpen: boolean }) => (
  <span className="relative inline-flex h-[1em] w-[1em] items-center justify-center">
    <span className={cn(LAYER, isOpen ? "opacity-0" : "opacity-100")}>
      <SidebarSimple className="rotate-180" weight="regular" />
    </span>
    <span className={cn(LAYER, isOpen ? "opacity-100" : "opacity-0")}>
      <SidebarSimple className="rotate-180" weight="fill" />
    </span>
  </span>
)

export default InspectorToggleIcon
